<span>This {{node.type | lowercase}} was generated by </span>
@if (canDisplayPatternLink) {
  <a (click)='navigateToPattern(pattern.patternId)'>
    {{pattern.name}}
    <mat-icon>open_in_new</mat-icon>
  </a>
}
pattern.
